import { request } from '@/lib/api'

/** Своё устройство в списке; токен сервер не возвращает никогда (#120). */
export interface PushDevice {
  id: string
  channel: 'webpush' | 'fcm' | 'rustore'
  label?: string | null
  registeredAt: string
  lastSeenAt: string
  lastSuccessAt?: string | null
  /** Есть — устройство отключено службой push (подписка отозвана, приложение удалено). */
  disabledReason?: string | null
}

/**
 * Что можно подключить и куда push уже уходит.
 *
 * Пустые поля сервер не отдаёт (`non_null`), поэтому ключ VAPID сравнивается нестрого.
 */
export interface PushOverview {
  webPushAvailable: boolean
  webPushPublicKey?: string | null
  fcmAvailable: boolean
  rustoreAvailable: boolean
  devices: PushDevice[]
}

export interface DeviceRegistration {
  channel: 'webpush' | 'fcm' | 'rustore'
  token: string
  p256dh?: string
  auth?: string
  label?: string
}

export interface RegisteredDevice {
  id: string
  channel: string
  deliverable: boolean
  reason?: string | null
}

export function fetchPushOverview(signal?: AbortSignal): Promise<PushOverview> {
  return request<PushOverview>('/notifications/push', { signal })
}

export function registerDevice(registration: DeviceRegistration): Promise<RegisteredDevice> {
  return request<RegisteredDevice>('/notifications/devices', { method: 'POST', body: registration })
}

/** Токен — в теле, а не в адресе: адрес подписки не должен оседать в журналах прокси. */
export function unregisterDevice(token: string): Promise<void> {
  return request<void>('/notifications/devices/unregister', { method: 'POST', body: { token } })
}

export function removeDevice(id: string): Promise<void> {
  return request<void>(`/notifications/devices/${encodeURIComponent(id)}`, { method: 'DELETE' })
}
